import { FieldError } from 'react-hook-form';

export function getErrorForField(
    fieldName: string,
    errors: Record<string, FieldError | undefined>
) {
    if (!errors[fieldName]) {
        return '';
    }
    // FIXME: 3.5.3 version of typescript has an issue so when version is upgraded please remove this hack
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return errors[fieldName]!.message || '';
}

interface BackendErrorType {
    message: string;
    param: string;
}

export function setBackendErrors(
    errors: BackendErrorType[],
    setError: (fieldName: string, error: Omit<FieldError, 'type'>) => void
) {
    errors.forEach((e) => {
        setError(e.param, {
            message: e.message,
        });
    });
}
